import { request } from 'src/common/rest/index';

const get = (sku, locale) => {
  if (!sku || !locale) {
    throw new Error('Missing SKU or Locale when trying to fetch Prismic product.');
  }
  return request.get(
    `/website-api/v1/prismic/product/${sku}/${locale.toLowerCase()}`,
    null,
    {
      headers: {
        'content-type': 'application/json',
      },
    },
  );
};

const getByMultipleLocales = async (productSku, contentLocales) => {
  const productList = await Promise.all(contentLocales.map(async locale => {
    try {
      const { body } = await get(productSku, locale);
      return body;
    } catch (error) {
      return null;
    }
  }));

  return productList.find(product => !!product);
};

export default {
  get,
  getByMultipleLocales,
};
